import PropTypes from "prop-types"
import { createContext, useContext, useState } from "react"
import { useMutation, useQuery } from "react-query"
import {
  createAdmin,
  deleteAdmin,
  listAdmins,
  listAppUsers,
  maxTakenCourseCount,
  publishedCoursesCount,
  setPermissions,
} from "~/actions/users"

import AppContext from "./App"

const UsersContext = createContext()
export default UsersContext

export const UsersContainer = ({ children }) => {
  const createAdminMutation = useMutation((data) => createAdmin(data))
  //state for search textfield
  const [searchValue, setSearchValue] = useState("")
  //state for active select
  const [activeValue, setActiveValue] = useState("all")
  //state for client value
  const [clientValue, setClientValue] = useState("all")
  // state for sso connection value
  const [accountCreationValue, setAccountCreationValue] = useState("all")
  //state for courses count slider
  const [sliderValue, setSliderValue] = useState([])
  //state for debounced courses count slider
  const [debouncedSliderValue, setDebouncedSliderValue] = useState([])
  //courses count initialValue
  const [coursesCount, setCoursesCount] = useState(null)
  // max courses taken by a user
  const [takenCourseCount, setTakenCourseCount] = useState(null)
  //state for user type
  const [userTypeValue, setUserTypeValue] = useState("user")
  //total of users and users showed
  const [total, setTotal] = useState(null)
  const [showing, setShowing] = useState(null)
  const [sort, setSort] = useState({ name: "id", direction: "" })

  const { authUser } = useContext(AppContext)

  const {
    data: admins,
    refetch: refetchAdmins,
    isLoading: listAdminLoading,
  } = useQuery("admins", () => listAdmins(), {
    enabled: !!authUser,
  })

  // const { data: waitlist, isLoading: waitlistLoading } = useQuery(
  //   "waitlist",
  //   () => getWailist(),
  //   {
  //     enabled: !!authUser,
  //   }
  // )

  const listAppUsersMutation = useMutation((data) => listAppUsers(data))

  const publishedCoursesCountMutation = useMutation(() =>
    publishedCoursesCount(),
  )
  const maxTakenCourseCountMutation = useMutation(() => maxTakenCourseCount())

  const setPermissionsMutation = useMutation((data) => setPermissions(data))
  const { isLoading: deleteAdminLoading, ...deleteAdminMutation } = useMutation(
    (data) => deleteAdmin(data),
  )

  return (
    <UsersContext.Provider
      value={{
        createAdminMutation,
        refetchAdmins,
        setPermissionsMutation,
        deleteAdminMutation,
        listAdminLoading,
        deleteAdminLoading,
        listAppUsersMutation,
        searchValue,
        setSearchValue,
        activeValue,
        setActiveValue,
        clientValue,
        setClientValue,
        setTotal,
        total,
        showing,
        setShowing,
        sort,
        setSort,
        admins,
        // waitlist,
        // waitlistLoading,
        sliderValue,
        setSliderValue,
        publishedCoursesCountMutation,
        maxTakenCourseCountMutation,
        coursesCount,
        setCoursesCount,
        takenCourseCount,
        setTakenCourseCount,
        debouncedSliderValue,
        setDebouncedSliderValue,
        userTypeValue,
        setUserTypeValue,
        accountCreationValue,
        setAccountCreationValue,
      }}
    >
      {children}
    </UsersContext.Provider>
  )
}

UsersContainer.propTypes = {
  children: PropTypes.node,
}
